import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController, ModalController, Events, PopoverController, Platform, Alert, AlertController } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { AppState } from '../../config/state';
import { PatronProvider, PatronCheckout, PatronHold, PatronFine } from '../../providers/patron/patron';
import { IlsProvider } from '../../providers/ils/ils';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoSelfcheckCheckoutPage } from '../co-selfcheck-checkout/co-selfcheck-checkout';
import moment from 'moment';
import { CoPatronFeesPage } from '../co-patron-fees/co-patron-fees';
import { PrintingProvider } from '../../providers/printing/printing';
import { DigitalItemsProvider } from '../../providers/digital-items/digital-items';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { CoRenewalInformationPopoverComponent } from '../../components/co-renewal-information-popover/co-renewal-information-popover';
import { CoEmailInputComponent } from '../../components/co-email-input/co-email-input';
import { MailProvider } from '../../providers/mail/mail';

@IonicPage()
@Component({
  selector: 'page-co-selfcheck-account',
  templateUrl: 'co-selfcheck-account.html',
})
export class CoSelfcheckAccountPage {
	public showActivePatron = true;
	private accountTab: String = 'checkouts';
	private patronDetails: any = {};
	private reloadRunning: any = {
		checkouts:0,
		fines:0,
		holds:0,
	};
	public itemsPerPage: {checkouts: number, fines: number, holds: number} = {
		checkouts: 0,
		fines: 0,
		holds: 0
	};
	private fineCount: number = 0;
	private checkoutPage: number = 0;
	private holdPage: number = 0;
	private finePage: number = 0;
	private initDone: boolean = false;
	private feesToPay: Array<any> = [];
	private feesCountToPay: number = 0;
	private feesAmountToPay: number = 0;
	private renewedCount: number = 0;
	private renewedItems: Array<any> = [];
	private failRenewals: Array<any> = [];
	private holdReady: number = 0;
	private canPrintAgain: boolean = true;
	private wideScreen: boolean;
	private patron: any;
	private prefillScan: string;
	constructor(public navCtrl: NavController, public navParams: NavParams, private loginProvider: LoginProvider, private events: Events, private timeout: TimeoutFunctionsProvider, private state: AppState, private patronProvider: PatronProvider, private ilsProvoder: IlsProvider, private loading: LoadingController, private toast: ToastAlertsProvider, private modalCtrl : ModalController, private printingProvider: PrintingProvider, private digitalProvider : DigitalItemsProvider, private popoverCtrl : PopoverController, private mailProvider : MailProvider, private platform : Platform) {
		this.events.subscribe('timeoutCalled', () => {
			this.timeout.doLogoutFunctions(this)
			// if (this.state.loggedInPatronId) this.loginProvider.instantLogout(this.logoutTimer);
		  });
		if (this.state.cordovaAvailable){
			this.itemsPerPage = {
				checkouts: null,
				holds: null,
				fines: null
			};
		}
		this.state.patron && this.state.patron.barcode? this.patron = this.state.patron : this.patron = {};
		this.wideScreen = this.platform.width() > 600 && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable);
		if (this.navParams && this.navParams.data.scan){
      console.log(this.navParams.get('scan'));
      this.prefillScan = this.navParams.get('scan');
    }
    window.onresize = (e) => {
      this.wideScreen = (this.platform.width() > 600 && (!this.platform.isLandscape() ||this.platform.width() >= 1024)) && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable);
    };
    window.onresize = (e) => {
      setTimeout(() => {
        if ((this.platform.width() > 600 && (!this.platform.isLandscape() ||this.platform.width() >= 1024)) && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable)) {
          this.wideScreen = true;
        } else {
          this.wideScreen = false;
        }
      }, 225)
    };
  }

	onDomChange(event){
		if (!this.state.cordovaAvailable){
			this.itemsPerPage.checkouts = Math.floor((event.target.clientHeight - 160)/101);
			this.itemsPerPage.holds = Math.floor((event.target.clientHeight - 160)/101);
			this.itemsPerPage.fines = Math.floor((event.target.clientHeight - 230)/58);
		}

		// this.patronDetails = {"id":1710153,"owed":0,"name":"Testing 2","fines":[{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15,"amountPaid":0,"description":"test","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":10,"amountPaid":10,"description":"test 2","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15.1,"amountPaid":0,"description":"test 3","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15,"amountPaid":0,"description":"test","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":10,"amountPaid":10,"description":"test 2","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15.1,"amountPaid":0,"description":"test 3","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15,"amountPaid":0,"description":"test","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":10,"amountPaid":10,"description":"test 2","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15.1,"amountPaid":0,"description":"test 3","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15,"amountPaid":0,"description":"test","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":10,"amountPaid":10,"description":"test 2","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15.1,"amountPaid":0,"description":"test 3","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15,"amountPaid":0,"description":"test","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":10,"amountPaid":10,"description":"test 2","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15.1,"amountPaid":0,"description":"test 3","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15,"amountPaid":0,"description":"test","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":10,"amountPaid":10,"description":"test 2","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15.1,"amountPaid":0,"description":"test 3","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15,"amountPaid":0,"description":"test","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":10,"amountPaid":10,"description":"test 2","bib":null},{"id":123,"lastUpdate":"2019-05-29","name":"name string","amount":15.1,"amountPaid":0,"description":"test 3","bib":null}],"email":"cathy.bartel@toledolibrary.org","phone":"4192595278","holds":[{"id":9613634,"bib":{"id":"2093018","ids":[{"type":"CallNumber","id":"791.4375 Rev"},{"type":"ISBN","id":"9780062374233"},{"type":"ISBN","id":"0062374230"},{"type":"MARC","id":"sky265267213"}],"title":"Harry Potter : the creature vault : the creatures and plants of the Harry Potter films","author":"Revenson, Jody, author.","authors":["Revenson, Jody,"],"publisher":null,"publishYear":2014,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":["9780062374233","0062374230"],"upcs":[],"subjects":["Potter, Harry","(Fictitious character)","Rowling, J. K.","Characters.","Harry Potter films."],"summaries":[],"series":[],"notes":["\"An Insight Editions Book.\""]},"status":"on hold.","postion":0,"holdDate":"2019-05-29","queueLength":1,"pickupLocation":{"code":"aa","name":"Main Library"}},{"id":9613635,"bib":{"id":"1555971","ids":[{"type":"ISBN","id":"9780590353427"},{"type":"ISBN","id":"0590353403"},{"type":"ISBN","id":"059035342X"},{"type":"ISBN","id":"043936213X"},{"type":"ISBN","id":"9780758700162"},{"type":"ISBN","id":"9781338299144"},{"type":"LCCN","id":"   97039059"},{"type":"MARC","id":"37975719"}],"title":"Harry Potter and the sorcerer's stone","author":"Rowling, J. K.,  author.","authors":["Rowling, J. K., "],"publisher":null,"publishYear":1998,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":["9780590353427","0590353403","059035342X","043936213X","9780758700162","9781338299144"],"upcs":[],"subjects":["Witches","Fiction.","Wizards","Schools","Magical powers","Orphans","Sorcery","Good vs. evil","Destiny","Fantasy.","Fantasy","Magic","ssi","Mystery","Adventure","Fiction","Juvenile","Cinematization","Movie"],"summaries":[{"text":"Rescued from the outrageous neglect of his aunt and uncle, a young boy with a great destiny proves his worth while attending Hogwarts School for Wizards and Witches.","source":null}],"series":["Harry Potter series ; "],"notes":["Published by arrangement with Bloomsbury Pub. Plc."]},"status":"on hold.","postion":0,"holdDate":"2019-05-29","queueLength":1,"pickupLocation":{"code":"aa","name":"Main Library"}},{"id":9613634,"bib":{"id":"2093018","ids":[{"type":"CallNumber","id":"791.4375 Rev"},{"type":"ISBN","id":"9780062374233"},{"type":"ISBN","id":"0062374230"},{"type":"MARC","id":"sky265267213"}],"title":"Harry Potter : the creature vault : the creatures and plants of the Harry Potter films","author":"Revenson, Jody, author.","authors":["Revenson, Jody,"],"publisher":null,"publishYear":2014,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":["9780062374233","0062374230"],"upcs":[],"subjects":["Potter, Harry","(Fictitious character)","Rowling, J. K.","Characters.","Harry Potter films."],"summaries":[],"series":[],"notes":["\"An Insight Editions Book.\""]},"status":"on hold.","postion":0,"holdDate":"2019-05-29","queueLength":1,"pickupLocation":{"code":"aa","name":"Main Library"}},{"id":9613635,"bib":{"id":"1555971","ids":[{"type":"ISBN","id":"9780590353427"},{"type":"ISBN","id":"0590353403"},{"type":"ISBN","id":"059035342X"},{"type":"ISBN","id":"043936213X"},{"type":"ISBN","id":"9780758700162"},{"type":"ISBN","id":"9781338299144"},{"type":"LCCN","id":"   97039059"},{"type":"MARC","id":"37975719"}],"title":"Harry Potter and the sorcerer's stone","author":"Rowling, J. K.,  author.","authors":["Rowling, J. K., "],"publisher":null,"publishYear":1998,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":["9780590353427","0590353403","059035342X","043936213X","9780758700162","9781338299144"],"upcs":[],"subjects":["Witches","Fiction.","Wizards","Schools","Magical powers","Orphans","Sorcery","Good vs. evil","Destiny","Fantasy.","Fantasy","Magic","ssi","Mystery","Adventure","Fiction","Juvenile","Cinematization","Movie"],"summaries":[{"text":"Rescued from the outrageous neglect of his aunt and uncle, a young boy with a great destiny proves his worth while attending Hogwarts School for Wizards and Witches.","source":null}],"series":["Harry Potter series ; "],"notes":["Published by arrangement with Bloomsbury Pub. Plc."]},"status":"on hold.","postion":0,"holdDate":"2019-05-29","queueLength":1,"pickupLocation":{"code":"aa","name":"Main Library"}},{"id":9613634,"bib":{"id":"2093018","ids":[{"type":"CallNumber","id":"791.4375 Rev"},{"type":"ISBN","id":"9780062374233"},{"type":"ISBN","id":"0062374230"},{"type":"MARC","id":"sky265267213"}],"title":"Harry Potter : the creature vault : the creatures and plants of the Harry Potter films","author":"Revenson, Jody, author.","authors":["Revenson, Jody,"],"publisher":null,"publishYear":2014,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":["9780062374233","0062374230"],"upcs":[],"subjects":["Potter, Harry","(Fictitious character)","Rowling, J. K.","Characters.","Harry Potter films."],"summaries":[],"series":[],"notes":["\"An Insight Editions Book.\""]},"status":"on hold.","postion":0,"holdDate":"2019-05-29","queueLength":1,"pickupLocation":{"code":"aa","name":"Main Library"}},{"id":9613635,"bib":{"id":"1555971","ids":[{"type":"ISBN","id":"9780590353427"},{"type":"ISBN","id":"0590353403"},{"type":"ISBN","id":"059035342X"},{"type":"ISBN","id":"043936213X"},{"type":"ISBN","id":"9780758700162"},{"type":"ISBN","id":"9781338299144"},{"type":"LCCN","id":"   97039059"},{"type":"MARC","id":"37975719"}],"title":"Harry Potter and the sorcerer's stone","author":"Rowling, J. K.,  author.","authors":["Rowling, J. K., "],"publisher":null,"publishYear":1998,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":["9780590353427","0590353403","059035342X","043936213X","9780758700162","9781338299144"],"upcs":[],"subjects":["Witches","Fiction.","Wizards","Schools","Magical powers","Orphans","Sorcery","Good vs. evil","Destiny","Fantasy.","Fantasy","Magic","ssi","Mystery","Adventure","Fiction","Juvenile","Cinematization","Movie"],"summaries":[{"text":"Rescued from the outrageous neglect of his aunt and uncle, a young boy with a great destiny proves his worth while attending Hogwarts School for Wizards and Witches.","source":null}],"series":["Harry Potter series ; "],"notes":["Published by arrangement with Bloomsbury Pub. Plc."]},"status":"on hold.","postion":0,"holdDate":"2019-05-29","queueLength":1,"pickupLocation":{"code":"aa","name":"Main Library"}}],"barcode":"5000041980","address":["325 Michigan","Toledo, OH  43604"],"lastName":"Testing 2","checkouts":[{"id":21491097,"bib":{"id":"2071759","ids":[{"type":"UPC","id":"634457642126"},{"type":"ISBN","id":"0634457642126"},{"type":"MARC","id":"sky258866738"}],"title":"Benji [music CD]","author":"Sun Kil Moon (Musical group)","authors":[],"publisher":null,"publishYear":2014,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":false,"format":"MUSIC CD","language":null,"previewLink":null,"imageLinks":null,"isbns":["0634457642126"],"upcs":["634457642126"],"subjects":["Rock music","2011-2020.","Alternative rock music."],"summaries":[{"text":"Sun Kil Moon's latest release was recorded between March and August 2012. Sun Kil Moon, led by Mark Kozelek is a reflection on Mark's childhood years and his life.","source":null}],"series":[],"notes":["Musical compact disc.","Title from disc."]},"dueDate":"2019-06-13","outDate":"2019-05-23","barcode":"0002195323","renewals":0},{"id":21495839,"bib":{"id":"1935782","ids":[{"type":"CallNumber","id":"808.8193 Art"},{"type":"ISBN","id":"9781608190331"},{"type":"ISBN","id":"1608190331"},{"type":"LCCN","id":"  2009028888"},{"type":"MARC","id":"401150897"}],"title":"The Art of losing : poems of grief and healing","author":"","authors":[],"publisher":"Bloomsbury,","publishYear":2010,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":["9781608190331","1608190331"],"upcs":[],"subjects":["Death","Poetry.","Grief","Bereavement"],"summaries":[{"text":"Poems about the various stages of grief, with 150 selections from a variety of 20th-21st century poets.","source":null}],"series":[],"notes":["Includes index."]},"dueDate":"2019-06-14","outDate":"2019-05-24","barcode":"0001122598","renewals":0},{"id":21495838,"bib":{"id":"1150050","ids":[{"type":"MARC","id":"1863465"}],"title":"The dogs : a novel","author":"Calder, Robert.","authors":["Calder, Robert."],"publisher":"Delacorte Press/Quicksilver Books,","publishYear":1976,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":false,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":[],"upcs":[],"subjects":[],"summaries":[],"series":[],"notes":[]},"dueDate":"2019-06-14","outDate":"2019-05-24","barcode":"IQHY4","renewals":0},{"id":21495839,"bib":{"id":"1935782","ids":[{"type":"CallNumber","id":"808.8193 Art"},{"type":"ISBN","id":"9781608190331"},{"type":"ISBN","id":"1608190331"},{"type":"LCCN","id":"  2009028888"},{"type":"MARC","id":"401150897"}],"title":"The Art of losing : poems of grief and healing","author":"","authors":[],"publisher":"Bloomsbury,","publishYear":2010,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":["9781608190331","1608190331"],"upcs":[],"subjects":["Death","Poetry.","Grief","Bereavement"],"summaries":[{"text":"Poems about the various stages of grief, with 150 selections from a variety of 20th-21st century poets.","source":null}],"series":[],"notes":["Includes index."]},"dueDate":"2019-06-14","outDate":"2019-05-24","barcode":"0001122598","renewals":0},{"id":21495838,"bib":{"id":"1150050","ids":[{"type":"MARC","id":"1863465"}],"title":"The dogs : a novel","author":"Calder, Robert.","authors":["Calder, Robert."],"publisher":"Delacorte Press/Quicksilver Books,","publishYear":1976,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":false,"format":"PRINT MATL","language":null,"previewLink":null,"imageLinks":null,"isbns":[],"upcs":[],"subjects":[],"summaries":[],"series":[],"notes":[]},"dueDate":"2019-06-14","outDate":"2019-05-24","barcode":"IQHY4","renewals":0},{"id":21491097,"bib":{"id":"2071759","ids":[{"type":"UPC","id":"634457642126"},{"type":"ISBN","id":"0634457642126"},{"type":"MARC","id":"sky258866738"}],"title":"Benji [music CD]","author":"Sun Kil Moon (Musical group)","authors":[],"publisher":null,"publishYear":2014,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":false,"format":"MUSIC CD","language":null,"previewLink":null,"imageLinks":null,"isbns":["0634457642126"],"upcs":["634457642126"],"subjects":["Rock music","2011-2020.","Alternative rock music."],"summaries":[{"text":"Sun Kil Moon's latest release was recorded between March and August 2012. Sun Kil Moon, led by Mark Kozelek is a reflection on Mark's childhood years and his life.","source":null}],"series":[],"notes":["Musical compact disc.","Title from disc."]},"dueDate":"2019-06-13","outDate":"2019-05-23","barcode":"0002195323","renewals":0}],"firstName":null,"homeBranch":{"code":"bi","name":"Birmingham Branch"},"homeBranchId":"bi"};
	}
	ionViewWillEnter(): void {
	this.loginProvider.requireLogin(res=>{
		console.log(res);
		this.initDone = true;
		this.patron = res;
		this.reloadPatronData();

	}, false, false, true, this.prefillScan);

	}
	get checkouts():Array<PatronCheckout> {
		return  this.patronDetails && this.patronDetails.checkouts ? this.patronDetails.checkouts: [];
	}
	get holds():Array<PatronHold> {
		return  this.patronDetails && this.patronDetails.holds ? this.patronDetails.holds: [];
	}
	get fines():Array<PatronFine> {
		return  this.patronDetails && this.patronDetails.fines ? this.patronDetails.fines: [];
	}
	cancelHold(hold:PatronHold){
		let loader = this.loading.create({
			content: 'Canceling Hold'
		});
		loader.present();
		switch(hold.bib.src){
			case 'overdrive':
			case 'hoopla':
			case 'rbdigital':
				this.digitalProvider.cancelHolds(hold.bib.src, hold.bib, this.patron.barcode, this.patron.pin).then(res =>{
					try{
						this.state.patron.changedItems.push({
							"type":"cancelHold",
							"id": hold.id,
							"bib": hold.bib
						});
						if(!this.state.demo) this.reloadPatronData();
						loader.dismiss().catch(err=>{});
					}catch(err){
						console.error(err);
						loader.dismiss().catch(err=>{});
					}
				}).catch(err =>{
					loader.dismiss().catch(err=>{});
				});
			break;
			case 'sierra':
			case 'polaris':
			case 'sirsi':
			case 'sd':
			default:
				this.ilsProvoder.cancelHold(this.patron.barcode, hold.id, this.patron.pin).then(res=>{
					try{
						this.state.patron.changedItems.push({
							"type":"cancelHold",
							"id": hold.id,
							"bib": hold.bib
						});
						this.reloadPatronData();
						loader.dismiss().catch(err=>{});
					}catch(err){
						console.error(err);
						loader.dismiss().catch(err=>{});
					}
				}).catch(err=>{
					loader.dismiss().catch(err=>{});
				});
			break;
		}
	}
	freezeHold(hold:PatronHold){
		if (!hold.frozen){
			let loader = this.loading.create({
				content: 'Freezing Hold'
			});
			loader.present();
			this.ilsProvoder.freezeHold(this.patron.barcode, this.patron.pin, hold.id).then(res =>{
				loader.dismiss().catch(err=>{});
				if (res.status){
					if(!this.state.demo) this.reloadPatronData();
				} else {
					this.toast.showAlert("title",res.message,'warning',5000);
				}
			}).catch(err=>{
				this.toast.showAlert("title",err.message,'warning',5000);
				loader.dismiss().catch(err=>{});
			});
		} else if (hold.frozen){
			let loader = this.loading.create({
				content: 'Unfreezing Hold'
			});
			loader.present();
			this.ilsProvoder.unfreezeHold(this.patron.barcode, this.patron.pin, hold.id).then(res =>{
				loader.dismiss().catch(err=>{});
				if (res.status){
					if(!this.state.demo) this.reloadPatronData();
				} else {
					this.toast.showAlert("title",res.message,'warning',5000);
				}
			}).catch(err=>{
				this.toast.showAlert("title",err.message,'warning',5000);
				loader.dismiss().catch(err=>{});
			});
		}
	}
	itemCheckout(){
	this.state.nav.push(CoSelfcheckCheckoutPage);
	}
	returnOverdrive(item){
		let loader = this.loading.create({content: 'Checking in item...'});
    loader.present();
    switch(item.bib.src){
      case 'overdrive':
        this.digitalProvider.checkInDigitalItem(item.bib.src, item.bib, this.patron.barcode, this.patron.pin).then(res=>{
			try{
				loader.dismiss().catch(err=>{});
				if (res && !res.message){
								this.state.patron.changedItems.push({
									"type":"return",
									"id": item.id,
									"dueDate": item.dueDate,
									"bib": item.bib
								});
					this.toast.showAlert('','Item returned successfully!','success', 5000);
					this.reloadPatronCheckouts();
				} else {
					this.toast.showAlert('',res.message||'Failed to return item','', 5000);
				}
			}catch(err){
				console.error(err);
				loader.dismiss().catch(err=>{});
				this.toast.showAlert('','Failed to return item, please see a librarian','', 5000);
			}
		}).catch(err =>{
			loader.dismiss().catch(err=>{});
			this.toast.showAlert('','Failed to return item, please see a librarian','', 5000);
		});
      break;
      default:
        console.log('source not supported yet',item.bib.src);
      break;
    }
	}
	renewCheckout(checkout){
		if (checkout.hasBeenRenewed){
			this.toast.showAlert('','Item has already been renewed');
			return;
		}
		let loader = this.loading.create({
			content: 'Renewing Item'
		  });
			loader.present();
			if (this.state.patron && !this.state.patron.changedItems) this.state.patron.changedItems = [];
			//DEMO MODE RENEW
			if (this.state.demo){
				console.log(checkout);
				this.renewedItems.push({
					"status":true,
					"dueDate": moment(checkout.dueDate).add(3, 'weeks').format('YYYY-MM-DD'),
					"message":null,
					"hasBeenRenewed": true,
					"item":{
						"itemIdentifier":checkout.bib.id,
						"titleIdentifier":checkout.bib.title,
						"mediaType":checkout.bib.format,
						"itemProperties":"",
						"checkoutOk":true,
						"screenMessage":[]
					}
				});
				if (this.state.patron && !this.state.patron.changedItems) this.state.patron.changedItems.push({
					"type": 'renew',
					"status":true,
					"dueDate": moment(checkout.dueDate).add(3, 'weeks').format('YYYY-MM-DD'),
					"message":null,
					"id": checkout.id,
					"item":{
						"itemIdentifier":checkout.bib.id,
						"titleIdentifier":checkout.bib.title,
						"mediaType":checkout.bib.format,
						"itemProperties":"",
						"checkoutOk":true,
						"screenMessage":[],
					}
				});
				checkout.dueDate = moment(checkout.dueDate).add(3, 'weeks').format('YYYY-MM-DD');
				checkout.hasBeenRenewed = true;
				loader.dismiss().catch(err=>{});
				return;
			}
			//REAL RENEW
			this.ilsProvoder.renewBook(checkout.id.toString(), this.patron.barcode, this.patron.pin).then(res=>{
				try{
					if (res && res.status && !moment(checkout.dueDate).isSame(res.dueDate, 'day')) {
						checkout.dueDate = res.dueDate;
						checkout.hasBeenRenewed = true;
						this.renewedCount++;
						this.renewedItems.push({
							"status":true,
							"dueDate": checkout.dueDate,
							"message":null,
							"item":{
								"itemIdentifier":checkout.bib.id,
								"titleIdentifier":checkout.bib.title,
								"mediaType":checkout.bib.format,
								"itemProperties":"",
								"checkoutOk":true,
								"screenMessage":[]
							}
						});
						if (this.state.patron) this.state.patron.changedItems.push({
							"type": 'renew',
							"status":true,
							"dueDate": checkout.dueDate,
							"message":null,
							"id": checkout.id,
							"item":{
								"itemIdentifier":checkout.bib.id,
								"titleIdentifier":checkout.bib.title,
								"mediaType":checkout.bib.format,
								"itemProperties":"",
								"checkoutOk":true,
								"screenMessage":[],
							}
						});
						this.toast.showAlert('','Item renewed successfully!',"success");
				} else {
					this.toast.showAlert('',`Failed to renew item, ${res.message || 'Please see a librarian'}`,'warning');
				}
				loader.dismiss().catch(err=>{});
			}catch(err){
				console.error(err);
				this.toast.showAlert('',`Sorry, failed to renew item`,'warning');
				loader.dismiss().catch(err=>{});
			}
		}).catch(err=>{
			this.toast.showAlert('',`Sorry, failed to renew item`,'warning');
			loader.dismiss().catch(err=>{});
		});
	}
	renewAllItems(){
		let loader = this.loading.create({
			content: 'Renewing All items'
		});
		loader.present();

		//DEMO MODE RENEW ALL
		if (this.state.demo){
			this.renewedItems = [];
			if (this.state.patron && !this.state.patron.changedItems) this.state.patron.changedItems = [];
			this.patronDetails.checkouts.map(item => {

				if (!item.hasBeenRenewed) item.dueDate = moment(item.dueDate).add(3, 'weeks').format("YYYY-MM-DD");
				this.renewedItems.push({
					"status":true,
					"dueDate": item.dueDate,
					"message":null,
					"item":{
						"itemIdentifier":item.bib.id,
						"titleIdentifier":item.bib.title,
						"mediaType":item.bib.format,
						"itemProperties":"",
						"checkoutOk":true,
						"screenMessage":[]
					},
					"bib":item.bib
				});
				if (!item.hasBeenRenewed && this.state.patron){
					this.state.patron.changedItems.push({
						"type": 'renew',
						"status":true,
						"dueDate": item.dueDate,
						"message":null,
						"id": item.id,
						"item":{
							"itemIdentifier":item.bib.id,
							"titleIdentifier":item.bib.title,
							"mediaType":item.bib.format,
							"itemProperties":"",
							"checkoutOk":true,
							"screenMessage":[],
						},
						"bib":item.bib
					});
				}
				item.hasBeenRenewed = true;
				return item;
			});

			loader.dismiss().catch(err=>{});

			let popover = this.popoverCtrl.create(CoRenewalInformationPopoverComponent, { renewals: this.renewedItems, failures: this.failRenewals }, { cssClass: 'renewals-popover', showBackdrop: true });
			popover.present();
			return
		}
		//REAL RENEW ALL
		this.ilsProvoder.renewAllSip2(this.patron.barcode, this.patron.pin, this.state.locationId.toString()).then(res=>{
			try{
				if (res && res.status) {
					this.renewedItems = [];
					this.failRenewals = [];
					if (this.state.patron && !this.state.patron.changedItems) this.state.patron.changedItems = [];
					res.renewedItems.forEach(renewal => {
						let bib = this.patronDetails.checkouts.find(e => e.barcode === renewal);
						if(bib){
						this.renewedItems.push({
							"status":true,
							"dueDate": bib.dueDate,
							"message":null,
							"item":{
								"itemIdentifier":bib.bib.id,
								"titleIdentifier":bib.bib.title,
								"mediaType":bib.bib.format,
								"itemProperties":"",
								"checkoutOk":true,
								"screenMessage":[]
							},
							"bib":bib.bib
						});
						if (this.state.patron) this.state.patron.changedItems.push({
							"type": 'renew',
							"status":true,
							"dueDate": bib.dueDate, // THIS ISN'T THE NEW DUEDATE
							"message":null,
							"id": bib.id,
							"item":{
								"itemIdentifier":bib.bib.id,
								"titleIdentifier":bib.bib.title,
								"mediaType":bib.bib.format,
								"itemProperties":"",
								"checkoutOk":true,
								"screenMessage":[],
							},
							"bib":bib.bib
						});
						this.renewedCount++;
						}
					});
					res.unrenewedItems.forEach(failure => {
						let bib = this.patronDetails.checkouts.find(e => e.barcode === failure);
						if(bib){
						this.failRenewals.push({
							"status":false,
							"dueDate": null,
							"message":null,
							"item":{
								"itemIdentifier":bib.bib.id,
								"titleIdentifier":bib.bib.title,
								"mediaType":bib.bib.format,
								"itemProperties":"",
								"checkoutOk":true,
								"screenMessage":[]
							},
							"bib":bib.bib
						});
						if(this.state.patron) this.state.patron.changedItems.push({
							"type": 'failedrenew',
							"status":false,
							"dueDate": null,
							"message":null,
							"id": bib.id,
							"item":{
								"itemIdentifier":bib.bib.id,
								"titleIdentifier":bib.bib.title,
								"mediaType":bib.bib.format,
								"itemProperties":"",
								"checkoutOk":true,
								"screenMessage":[],
							},
							"bib":bib.bib
						});
					}
					});
					loader.dismiss().catch(err=>{});

					let popover = this.popoverCtrl.create(CoRenewalInformationPopoverComponent, { renewals: this.renewedItems, failures: this.failRenewals }, { cssClass: 'renewals-popover', showBackdrop: true });
					popover.present();

					popover.onDidDismiss(()=>{
						this.reloadPatronCheckouts();
					})
				} else {
					loader.dismiss().catch(err=>{});
					this.toast.showAlert('',`Failed to renew items, ${res.message || 'Please see a librarian'}`,'warning');
				}
			}catch(err){
				console.error(err);
				this.toast.showAlert('',`Sorry, failed to renew item`,'warning');
				loader.dismiss().catch(err=>{});
			}
		})
	}
	reloadPatronData(){
		this.patronDetails={};
		this.reloadPatronCheckouts();
		this.reloadPatronHolds();
		this.reloadPatronFines();
	}
	reloadPatronInfo(){
		switch(this.accountTab){
			case ('checkouts'):
				this.reloadPatronCheckouts();
			break;
			case ('holds'):
				this.reloadPatronHolds();
			break;
			case ('fines'):
				this.reloadPatronFines();
			break;
		}
	}
	reloadPatronCheckouts(){

		// FOR TESTING RENEWALS
		// this.renewedCount++;
		// this.renewedItems.push({
		// 	"status":true,
		// 	"dueDate": "2020-12-12",
		// 	"message":null,
		// 	"item":{
		// 		"itemIdentifier": "123123124",
		// 		"titleIdentifier": "test1",
		// 		"mediaType": "book",
		// 		"itemProperties":"",
		// 		"checkoutOk":true,
		// 		"screenMessage":[]
		// 	}
		// });
		this.checkoutPage = 0;
		this.patronDetails.checkouts = [];
		this.reloadRunning.checkouts++;
		this.patronProvider.getCheckouts(this.patron.barcode, this.patron.pin, this.patron.id).then(checkouts=>{
			this.patronProvider.getDigitalCheckouts(this.patron.barcode, this.patron.pin).then(digital=>{
				checkouts = checkouts.concat(digital);
				checkouts.sort((a,b)=>{
					return moment(a.dueDate).diff(b.dueDate);
				});

				//THIS IS TO ATTACH NEW RENEW DATE TO CHANGED ITEMS AFTER GOING THROUGH RENEW ALL
				if (this.state.patron && this.state.patron.changedItems && this.state.patron.changedItems.length > 0){
					this.state.patron.changedItems.map(changed =>{
						if (changed.type === 'renew'){
							let c = checkouts.find(item => item.id === changed.id);
							if (c){
								changed.dueDate = c.dueDate;
								return changed;
							}
						}
					});
					// console.log(this.state.patron.changedItems);
				}

				this.reloadRunning.checkouts--;
				this.patronDetails.checkouts = checkouts;
				// console.log(this.patronDetails.checkouts);
			}).catch(err=>{this.reloadRunning.checkouts--})
		}).catch(err=>{this.reloadRunning.checkouts--})
	}
	reloadPatronHolds(){
		this.holdReady = 0;
		this.holdPage = 0;
		this.patronDetails.holds = [];
		this.reloadRunning.holds++;
		this.patronProvider.getHolds(this.patron.barcode, this.patron.pin, this.patron.id).then(holds=>{
			holds.forEach(h=>{
				if(h.postion <= 1 && h.isReady){
					this.holdReady++;
				}
			});
			// this.patronDetails.holds = holds; UNCOMMENT IF NOT LOOKING FOR DIGITAL HOLDS
			// this.reloadRunning.holds--;
			this.patronProvider.getDigitalHolds(this.patron.barcode, this.patron.pin).then(digital =>{
				holds = holds.concat(digital);
				// console.log(holds, digital);
				this.patronDetails.holds = holds;
				this.reloadRunning.holds--;
			}).catch(err =>{
				this.patronDetails.holds = holds;
				this.reloadRunning.holds--;
			})
		}).catch(err=>{this.reloadRunning.holds--});
	}

	reloadPatronFines(){
		this.finePage = 0;
		this.fineCount = 0;
		this.patronDetails.fines = [];
		this.reloadRunning.fines++;
		this.patronProvider.getFines(this.patron.barcode, this.patron.pin).then(fines=>{
			fines.map(fine=>{
				fine.willPay = false;
				if (fine.amount > fine.amountPaid) this.fineCount++;
				return fine
			});
			this.reloadRunning.fines--;
			this.patronDetails.fines = fines;
		}).catch(err=>{this.reloadRunning.fines--});
	}
	openFeesModal(patron, fines){
		// replace the total in here with total amount to be paid
    let modal = this.modalCtrl.create(CoPatronFeesPage, { fines: fines, patron: patron, total: this.feesAmountToPay }, {cssClass: "full-screen-modal"});
		modal.present();

		modal.onDidDismiss((paid) => {
			if (paid) {
				this.patronDetails.fines.forEach(f => {
					if (f.willPay) f.willPay = false;
				});
			};
		});
	}

	payFines(){
    this.feesToPay = this.patronDetails.fines.filter(fee=>{
      return fee.willPay;
    });
    this.openFeesModal(this.patronDetails, this.feesToPay);
	}
	updateFeeTotal(event, fee){
		// if (event.checked === fee.willPay) return;
		// fee.willPay = event.checked;
    if (event.checked){
			this.feesCountToPay++;
      this.feesAmountToPay += fee.amount;
    } else {
			this.feesCountToPay--;
      this.feesAmountToPay -= fee.amount;
    };
  }
	printReceipt(){
		if (this.renewedCount <= 0 || this.renewedItems.length <= 0) return;

		this.canPrintAgain = false;
		this.printingProvider.printCheckoutItemReceipt({ receiptInfo: this.renewedItems, screenType: 'Renew', patron: this.patron, pastTense: 'renewed', submitTime: moment()}, true).then(res=>{
			setTimeout(()=>{this.canPrintAgain = true}, 6000);
			if (res) this.loginProvider.instantLogout();
		})
	}
	printAccountInfo(tab){
		if (this.patronDetails[tab].length <= 0) return;
		this.canPrintAgain = false;
		this.printingProvider.printCheckoutItemReceipt({ receiptInfo: this.patronDetails[tab], screenType: tab, patron: this.patron, pastTense: '', submitTime: moment()}, true).then(res=>{
			setTimeout(()=>{this.canPrintAgain = true}, 6000);
		})
	}
	emailAccountInfo(tab){
		if (this.patronDetails[tab].length <= 0) return;

		let inputPopup = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'email', email: this.patron.email  }, { cssClass: 'custom-email-input-popover' });
		let barcodeDetails, emailVars;
		let emailList = "";
		inputPopup.present({ ev: event });
		inputPopup.onDidDismiss(email => {
			if (email && email.info) {
				let loader = this.loading.create({
					content: 'Sending email'
				});
				loader.present();
				let params = {email: email.info, template: 'patron_account_info'};
				if (tab === 'fines'){
					this.patronDetails.fines.forEach(f => {
						emailList += `Fine description: ${f.description} ${f.bib? '\r\n Item: '+f.bib.title : ''} \r\n Total: $${f.amount.toFixed(2)} \r\n Amount Paid: $${(f.amountPaid ? f.amountPaid.toFixed(2) : "0.00")} \r\n Amount Owed: $${(f.amount - f.amountPaid).toFixed(2)} \r\n \r\n`
					});
				} else if(tab === 'checkouts') {
					this.patronDetails.checkouts.forEach(item => {
						emailList += `Title: ${item.bib.title} \r\n Id: ${item.id} \r\n ${item.barcode ? 'Barcode: '+item.barcode+'\r\n' : ''} ${item.dueDate? 'Due: ' + moment(item.dueDate).format('MM/DD/YYYY') : ''} \r\n \r\n`;
					});
				} else if(tab === 'holds') {
					this.patronDetails.holds.forEach(item => {
						emailList += `Title: ${item.bib.title} \r\n Id: ${item.id} \r\n ${item.barcode ? 'Barcode: '+item.barcode+'\r\n' : ''} ${item.postion ? 'Position: '+item.postion+(item.queueLength ? ' of '+item.queueLength : '')+'\r\n' : ''} ${item.status ? 'Status: '+item.status : ''} \r\n \r\n`;
					});
				}
				if (this.patron.barcode) {
					barcodeDetails = `Customer ID: **********${this.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}`
				}
				console.log("patron details", this.patron)
				emailVars = `
					date: "${moment().format("dddd MMMM Do, YYYY")}",
					first_name: "${this.patron.firstName? this.patron.firstName : ''}",
					screen_type: "${tab}",
					barcode_end: "${barcodeDetails || ''}",
					item_list: "${encodeURIComponent(emailList)}",
					total: "${this.patronDetails[tab].length}"
				`;
				this.mailProvider.sendGeneralEmail(params, emailVars).then(res => {
					loader.dismiss();
					if (res[0] && res[0].status) {
						this.toast.showAlert('', 'Your receipt has been sent!', 'success', 3000);
					} else {
						this.toast.triggerToast('Send failed, please retry', '');
					};
				});
			}
		});
	}
	closeMyAccount(logout:Boolean){
		if(logout){
			this.logout();
		}else{
		  this.state.nav.popToRoot();
		}
	}
	logout() {
		this.loginProvider.logout().then( done =>{
			if( done ){
				this.state.nav.popToRoot();
			}
		})
	}
	ionViewWillLeave(){
	//  debugger;
	// if (this.state.)
	}
}



// WEBPACK FOOTER //
// ./src/pages/co-selfcheck-account/co-selfcheck-account.ts